import Vue from "vue";

import DrawingsCatalogList from "./DrawingsCatalogList.vue";

export function load() {
    const selector = "drawingscatalog-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(DrawingsCatalogList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}